module.exports = __webpack_public_path__ + "static/media/icon-freadabrusca-cinza.e38d90e5.svg";